<div *ngIf="editForm" class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal" [menuComponent]="menuComponent"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.installationtrainingprovided.header' | translate }}</span>
        </h2>
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationtrainingprovided.from' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%">
              <div class="ir-form-group">
                <input type="date" class="ir-form-set" formControlName="from" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationtrainingprovided.to' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%">
              <div class="ir-form-group">
                <input type="date" class="ir-form-set" formControlName="to" />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <button
                *ngIf="customerAttendeesForms.controls.length === 0"
                type="button"
                class="ir-btn ir-btn--title ir-txt--right"
                style="margin-bottom: 2em"
                (click)="openImportContactsModal()"
              >
                <span>{{ 'plugins.installationcustomerattendees.import-contacts' | translate }}</span>
              </button>
            </td>
          </tr>
        </table>
        <table
          class="ir-modal-table ir-content--modal th-content th-content-customer"
          formArrayName="customerAttendees"
          *ngFor="let item of customerAttendeesForms.controls; let i = index"
        >
          <tr>
            <td></td>
            <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
              <i class="material-icons" (click)="openCustomerDeleteConfirm(i)">remove_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{
                  'plugins.installationtrainingprovided.first-name' | translate
                }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <div class="ir-form-group">
                <input name="firstName" type="text" formControlName="firstName" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{
                  'plugins.installationtrainingprovided.last-name' | translate
                }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <input name="lastName" class="ir-form-set" type="text" formControlName="lastName" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationtrainingprovided.company' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <input name="company" class="ir-form-set" type="text" formControlName="company" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationtrainingprovided.function' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <input name="jobFunction" class="ir-form-set" type="text" formControlName="jobFunction" />
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationtrainingprovided.email' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" [formGroupName]="i">
              <input name="email" class="ir-form-set" type="text" formControlName="email" />
            </td>
          </tr>
          <tr class="th-plugin-line--checkbox label">
            <td class="margin-big">
              <h2>
                <span style="padding: 0">{{ 'plugins.installationtrainingprovided.modules' | translate }}</span>
              </h2>
            </td>
            <td colspan="3" class="include-action-plan">
              <div (click)="changeCheckboxValue(item.controls.useOfDocumentation)">
                <i class="material-icons" *ngIf="!item.controls.useOfDocumentation.value">check_box_outline_blank</i>
                <i class="material-icons important" *ngIf="item.controls.useOfDocumentation.value">check_box</i>
                <span>{{ 'plugins.installationtrainingprovided.use-of-doc' | translate }}</span>
              </div>
              <div (click)="changeCheckboxValue(item.controls.safetyDevices)">
                <i class="material-icons" *ngIf="!item.controls.safetyDevices.value">check_box_outline_blank</i>
                <i class="material-icons important" *ngIf="item.controls.safetyDevices.value">check_box</i>
                <span>{{ 'plugins.installationtrainingprovided.safety-devices' | translate }}</span>
              </div>
              <div (click)="changeCheckboxValue(item.controls.maintenance)">
                <i class="material-icons" *ngIf="!item.controls.maintenance.value">check_box_outline_blank</i>
                <i class="material-icons important" *ngIf="item.controls.maintenance.value">check_box</i>
                <span>{{ 'plugins.installationtrainingprovided.maintenance' | translate }} </span>
              </div>
              <div (click)="changeCheckboxValue(item.controls.machineOpAndControl)">
                <i class="material-icons" *ngIf="!item.controls.machineOpAndControl.value">check_box_outline_blank</i>
                <i class="material-icons important" *ngIf="item.controls.machineOpAndControl.value">check_box</i>
                <span>{{ 'plugins.installationtrainingprovided.machine-op-and-control' | translate }}</span>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="add($event)" #importCustomersModal></modal>
<confirm
  #customerDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>training record</strong>?'"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
